// src/components/SystemManifesto.jsx
import React from 'react';
import { useSisConfig } from '../contexts/SisConfigUi';
import { useVersion } from '../hooks/useVersion';

const SystemManifesto = () => {
  const { sisConfig } = useSisConfig();
  const manifesto = sisConfig?.manifiesto;
  const version = useVersion();
  
  if (!manifesto) {
    return null;
  }
  
  return (
    <div className="w-full bg-white border border-gray-200 rounded-xl shadow-sm p-8">
      <div className="text-center">
        
        {/* Título principal */}
        <h1 className="text-2xl font-bold text-gray-900 mb-2 tracking-wide">
          {manifesto.title}
        </h1>
        
        {/* Subtitle */}
        <p className="text-sm text-gray-600 italic mb-4">
          {manifesto.subtitle}
        </p>
        
        {/* Separador decorativo */}
        <div className="flex items-center justify-center mb-4">
          <div className="h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent w-3/4"></div>
        </div>
        
        {/* Pilares */}
        <div className="flex flex-wrap items-center justify-center gap-3 mb-4 text-sm font-semibold text-blue-700">
          {manifesto.pillars?.map((pillar, idx) => (
            <React.Fragment key={idx}>
              <span>{pillar}</span>
              {idx < manifesto.pillars.length - 1 && (
                <span className="text-gray-400">•</span>
              )}
            </React.Fragment>
          ))}
        </div>
        
        {/* Principios */}
        <p className="text-xs text-gray-600 mb-4">
          {manifesto.principle}
        </p>
        
        {/* Fundamento */}
        <p className="text-xs text-gray-600 mb-4">
          {manifesto.foundation}
        </p>
        
        {/* Separador decorativo */}
        <div className="flex items-center justify-center mb-3">
          <div className="h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent w-1/2"></div>
        </div>
        
        {/* Footer con branding */}
        <div className="flex flex-col items-center gap-1">
          <div className="flex items-center gap-2 text-sm">
            <span className="text-2xl">{manifesto.branding?.icon}</span>
            <span className="font-bold text-gray-800">{manifesto.branding?.product}</span>
            <span className="text-gray-500">© {manifesto.branding?.year?.replace('{year}', new Date().getFullYear())} - {manifesto.branding?.company}</span>
          </div>
          <p className="text-xs text-blue-600 font-medium italic">
            "{manifesto.tagline}"
          </p>
          {version && (
            <span className="text-[10px] text-gray-400 mt-1">Ver. {version}</span>
          )}
        </div>
        
      </div>
    </div>
  );
};

export default SystemManifesto;